import React, { useEffect, useState } from "react";
import styles from "../Profile/Profile.module.css";
import multipleEntry from "../../assests/popup/multipleEntry.svg";
import { useNavigate } from "react-router";

function EligiblePopup({
  buttonColor,
  setPopup,
  contestDetails,
  heading,
  description,
  button2,
  button2Function,
}) {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);
  const { orgDomain, campaignUniqueText } = contestDetails;
  const navigate = useNavigate();
  return (
    <div className="fixed top-0 left-0 w-[100%] h-[100%] flex items-center justify-center p-[20px] z-100 text-center z-10 popupBackground">
      <div className={styles.deteleme}>
        <img
          src={multipleEntry}
          alt=""
          className="w-[56px] h-[56px] mb-[24px]"
        />
        <p
          className="text-regular-medium px-[20px] mb-[16px]"
          style={{ color: buttonColor }}
        >
          {heading}
        </p>
        <p className="text-small text-[#CDCDCD] px-[20px]">{description}</p>
        <div className="seperator my-[20px]" />
        {setPopup && (
          <div className="flex flex-col gap-[16px] w-[100%]">
            <button
              className={styles.Deeleeete}
              onClick={() => setPopup(false)}
            >
              <p className="text-regular-medium">OK</p>
            </button>
          </div>
        )}
        {button2 && (
          <div className="flex flex-col gap-[16px] w-[100%]">
            <button className={styles.Deeleeete} onClick={button2Function}>
              <p className="text-regular-medium">{button2}</p>
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default EligiblePopup;
